import Swiper, { Navigation, Pagination } from 'swiper';

function swiperInit(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    slidesPerView: 1,
    autoHeight: true,
    loop: true,
    modules: [Navigation, Pagination],
    allowTouchMove: false,
    navigation: {
      prevEl: '.rooms-cards__pagination--prev',
      nextEl: '.rooms-cards__pagination--next',
    },
  });
}

window.document.addEventListener('DOMContentLoaded', () => {
  const swiperContainerClass = '.rooms-cards-swiper';

  swiperInit(swiperContainerClass);
});
